import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../common/type';
import { LoadingIcon } from '../../../components/LoadingIcon';
import { customerActionCreator } from '../../customers';
import { CheckoutScreen } from '../parts/ads-checkout-type';
import { AdsCheckoutPage } from './AdsCheckoutPage';
import { AdsSelectionPage } from './AdsSelectionPage';
import { AdsUserSelection } from './AdsUserSelection';

class AdsCheckoutContainer extends React.Component<IProps, IState> {
  state = {
    isLoading: true
  };

  render() {
    if (this.state.isLoading) {
      return <LoadingIcon />;
    }

    const props = this.props;
    switch (props.screen) {
      case CheckoutScreen.user:
        return <AdsUserSelection />;

      case CheckoutScreen.selection:
        return <AdsSelectionPage />;

      case CheckoutScreen.checkout:
        return <AdsCheckoutPage />;

      default:
        return <AdsUserSelection />;
    }
  }

  componentDidMount() {
    this.props.initCustomers().then(() => this.setState({ isLoading: false }));
  }
}

interface IStoreProps {
  screen: CheckoutScreen;
}

interface IDispatchProps {
  initCustomers: () => Promise<void>;
}

type IProps = IStoreProps & IDispatchProps;

interface IState {
  isLoading: boolean;
}

const mapStates = (state: IStore): IStoreProps => ({
  screen: state.adsCheckout.ui.screen
});

const mapDispatch = (dispatch: any): IDispatchProps => ({
  initCustomers: () => dispatch(customerActionCreator.initCustomerList())
});

export const AdsCheckout = connect(
  mapStates,
  mapDispatch
)(AdsCheckoutContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsCheckout.tsx